export const parseCampaignMessage = (message, username) => {
  const newMessage = {
    id: message.id,
    senderId: message.sender_id,
    senderType: message.sender_type,
    username: message.sender_username,
    campaignId: message.campaign_id,
    message: message.message,
    createdDate: message.created_at,
    updatedAt: message.updated_at,
    attachmentUrl: message.attachments_url,
    isMy: username === message.sender_username,
    isSms:
      message.sender_type === 'admin|sms' || message.sender_type === 'user|sms',
  };

  return newMessage;
};
